import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import CategoryNav from './CategoryNav'
import LatestPosts from './LatestPosts'
export default function BlogNav() {
    return (
        <div className="col-lg-4 col-md-12">
        <aside className="widget-area" id="secondary">
            <div className="widget widget_search">
                <form className="search-form">
                    <label>
                        <span className="screen-reader-text">Search for:</span>
                        <input type="search" className="search-field" placeholder="Search..."/>
                    </label>
                    
                    <button type="submit">
                        <i className="flaticon-search"></i>
                    </button>
                </form>
            </div>

           <LatestPosts/>
            <section className="widget widget_categories">
                <h3 className="widget-title">Archives</h3>

                <ul>
                    <li><a href="#">May 2020</a></li>
                    <li><a href="#">April 2020</a></li>
                    <li><a href="#">June 2020</a></li>
                    <li><a href="#">julay 2020</a></li>
                    
                </ul>
            </section>
            
            <CategoryNav/>

            <section className="widget widget_tag_cloud">
                <h3 className="widget-title">Tags</h3>

                <div className="tagcloud">
                    <Link to={`/blog/${'Fashion'}/posts`}>Fashion</Link>
                    <Link to={`/blog/${'Education'}/posts`}>Education</Link>
                    <Link to={`/blog/${'Nation'}/posts`}>Nation</Link>
                    <Link to={`/blog/${'Study'}/posts`}>Study</Link>
                    <Link to={`/blog/${'Health'}/posts`}>Health</Link>
                    <Link to={`/blog/${'Food'}/posts`}>Food</Link>
                    <Link to={`/blog/${'Travel'}/posts`}>Travel</Link>
                    <Link to={`/blog/${'Science'}/posts`}>Science</Link>
                </div>
            </section>
        </aside>
    </div>
    )
}
